import { lazyWithRetry as lazy } from '@utils/lazyWithRetry';
import { RouteConfig } from '@routes/types';

const HomeWrapper = lazy(() => import('@page/HomeWrapper'));
const PageWrapper = lazy(() => import('@page/PageWrapper'));
const PageNotFound = lazy(() => import('@component/PageNotFound/PageNotFound'));
const IconsWrapper = lazy(() => import('@page/IconsWrapper'));
const SomethingWentWrong = lazy(
  () => import('@component/SomethingWentWrong/SomethingWentWrong')
);
const NoAuthorization = lazy(
  () => import('@component/NoAuthorization/NoAuthorization')
);
const MembersInfoLight = lazy(
  () =>
    import('@component/LightVersion/Members/MembersInfoLight/MembersInfoLight')
);
const MemberBenefits = lazy(
  () => import('@component/LightVersion/Members/MemberBenefits/MemberBenefits')
);
const MyRoomPreferences = lazy(
  () => import('@component/Member/MyRoomPreferences/MyRoomPreferences')
);
const AuthContactsLightNew = lazy(
  () =>
    import('@component/LightVersion/AuthContactsLightNew/AuthContactsLightNew')
);
const RidesPage = lazy(() => import('@component/RidesPage/RidesPage'));
const MyRoomAuditLogs = lazy(
  () => import('@component/AuditLog/MyRoomAuditLogs/MyRoomAuditLogs')
);
const ConfigWrapper = lazy(() => import('@page/ConfigWrapper'));

export const memberPortalRoutes: RouteConfig[] = [
  {
    path: '/',
    element: HomeWrapper,
    children: [
      {
        path: 'members',
        element: PageWrapper,
        children: [
          { path: 'information/:id', element: MembersInfoLight },
          { path: 'preferences/:id', element: MyRoomPreferences },
          { path: 'contacts/:id', element: AuthContactsLightNew },
          { path: 'benefits/:id', element: MemberBenefits },
          { path: 'rides/:id', element: RidesPage },
          { path: 'audit-logs/:id', element: MyRoomAuditLogs },
        ],
      },
    ],
  },
  {
    path: 'icons',
    element: IconsWrapper,
  },
  {
    path: 'configs',
    element: ConfigWrapper,
  },
  {
    path: 'wrong',
    element: SomethingWentWrong,
  },
  {
    path: 'no-authorization',
    element: NoAuthorization,
  },
  {
    path: '*',
    element: PageNotFound,
  },
];
